import { render, staticRenderFns } from "./FilterMonetizationTypes.vue?vue&type=template&id=218ef328"
import script from "./FilterMonetizationTypes.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterMonetizationTypes.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports